import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import PrivateRoute from "./components/PrivateRoute";
import Layout from "./components/Layout";

import Login from "./pages/Login";
import ListaParceiros from "./pages/ListaParceiros";
import ListaUsuarios from "./pages/ListaUsuarios";
import UsuarioDetalhes from "./pages/UsuarioDetalhes";
import ParceiroDetalhes from "./pages/ParceiroDetalhes";
import VidaAgenteDetalhada from "./pages/VidaAgenteDetalhada";
import DashboardGestaoComercial from "./pages/DashboardGestaoComercial";
import Hub from "./pages/Hub";
import MeuPerfil from "./pages/MeuPerfil";
import ListaTarefas from "./pages/ListaTarefas";
import ConfiguracoesAtividades from "./pages/ConfiguracoesAtividades";
import IntegracaoJoin from "./pages/IntegracaoJoin";
import ComissaoRepasse from "./pages/ComissaoRepasse";
import RelatorioChurn from "./pages/RelatorioChurn";
import Demo from "./pages/Demo";
import GpsTeste from "./pages/GpsTeste";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />

      <Route path="/demo" element={<Layout />}>
        <Route index element={<Demo />} />
      </Route>

      <Route path="/gps-teste" element={<GpsTeste />} />

      <Route
        element={(
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        )}
      >
        <Route path="/hub" element={<Hub />} />
        <Route path="/dashboard" element={<DashboardGestaoComercial />} />
        <Route path="/parceiros" element={<ListaParceiros />} />
        <Route path="/parceiros/:id" element={<ParceiroDetalhes />} />
        <Route path="/parceiros/:id/vida-agente" element={<VidaAgenteDetalhada />} />
        <Route path="/meu-perfil" element={<MeuPerfil />} />
        <Route path="/tarefas" element={<ListaTarefas />} />
        {/* Aberta a todos: o backend limita cada usuário à própria equipe (mesmo escopo do dashboard). */}
        <Route path="/relatorios/comissao-repasse" element={<ComissaoRepasse />} />
        <Route path="/relatorios/churn" element={<RelatorioChurn />} />
        <Route
          path="/usuarios"
          element={(
            <PrivateRoute somenteAdmin>
              <ListaUsuarios />
            </PrivateRoute>
          )}
        />
        <Route
          path="/usuarios/:id"
          element={(
            <PrivateRoute somenteAdmin>
              <UsuarioDetalhes />
            </PrivateRoute>
          )}
        />
        <Route
          path="/configuracoes-atividades"
          element={(
            <PrivateRoute somenteAdmin>
              <ConfiguracoesAtividades />
            </PrivateRoute>
          )}
        />
        <Route
          path="/integracao-join"
          element={(
            <PrivateRoute somenteAdmin>
              <IntegracaoJoin />
            </PrivateRoute>
          )}
        />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
